import { LSTORAGE_KEY } from 'src/constants';
import { IUserState } from 'src/interface';
import { ArrayUtils, StringUtils } from 'src/utils';
import LocalStore from 'src/utils/storage';

export const updateUserAssets = (state: IUserState, payload: IUserState) => {
    return {
        ...payload,
    };
};

export const follow = (
    state: IUserState,
    objectType: string,
    objectId: number
): IUserState => {
    const values = (state.follow[objectType] as Array<number>) || [];
    const isFollow: boolean = values.indexOf(objectId) > -1;

    return {
        ...state,
        follow: {
            ...state.follow,
            [objectType]: isFollow
                ? ArrayUtils.remove(values, objectId)
                : ArrayUtils.insert(values, objectId),
        },
    };
};

export const bookmark = (state: IUserState, id: number): IUserState => {
    const bookmark = state.bookmark || {};
    const isBookmark: boolean = bookmark.indexOf(id) > -1;

    return {
        ...state,
        bookmark: isBookmark
            ? ArrayUtils.remove(bookmark, id)
            : ArrayUtils.insert(bookmark, id),
    };
};

export const like = (state: IUserState, id: number): IUserState => {
    const likeState = state.like || [];
    const isExist = likeState.indexOf(id) > -1;

    if (isExist || typeof id === 'undefined') {
        return state;
    }
    const updatedLikes = likeState.concat(id);

    LocalStore.set(LSTORAGE_KEY.CONTENTS_LIKE, StringUtils.stringify(updatedLikes));

    return {
        ...state,
        like: updatedLikes,
    };
};
